import React, { Component } from 'react';
import { withUser } from '../../../../utility/withUser';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import './index.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

/**
 * Component for showing conversation.
 *
 * @extends React.Component
 */
class Conversation extends Component {
  /** @inheritdoc */
  render() {
    return (
      <div className="col-sm-12 col-md-9 empty-conversation">
        <div className="tab-content" id="nav-tabContent">
          <div className="tab-pane fade show active" id="list-1" role="tabpanel" aria-labelledby="list-1-list">
            <div className="row">
              <div className="col-sm-8">
                <div className="widget">
                  <h3 className="section-heading">Samtale  <span className="text-danger">(Afventer svar i 9 min.)</span></h3>
                  <div className="form-group">
                    <button className="btn btn-primary">Overtag samtale</button>
                  </div>
                  <div className="chat-messages">
                    <div className="message-in">
                      <ul className="message-in-meta">
                        <li>19:57 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Cupidatat quis ad sint excepteur laborum in esse qui. Et excepteur consectetur ex nisi eu do cillum ad laborum.</p>
                    </div>
                    <div className="message-out">
                      <ul className="message-in-meta">
                        <li>20:07 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Mollit et eu officia dolore sunt Lorem culpa qui commodo velit ex amet id ex. Officia anim incididunt laboris deserunt anim aute dolor incididunt veniam aute dolore do exercitation. Dolor nisi culpa ex ad irure in elit eu dolore. Ad laboris ipsum reprehenderit irure non commodo enim culpa commodo veniam incididunt veniam ad.</p>
                    </div>
                    <div className="message-in">
                      <ul className="message-in-meta">
                        <li>19:57 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Cupidatat quis ad sint excepteur laborum in esse qui. Et excepteur consectetur ex nisi eu do cillum ad laborum.</p>
                    </div>
                    <div className="message-out">
                      <ul className="message-in-meta">
                        <li>20:07 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Mollit et eu officia dolore sunt Lorem culpa qui commodo velit ex amet id ex. Officia anim incididunt laboris deserunt anim aute dolor incididunt veniam aute dolore do exercitation. Dolor nisi culpa ex ad irure in elit eu dolore. Ad laboris ipsum reprehenderit irure non commodo enim culpa commodo veniam incididunt veniam ad.</p>
                    </div>
                    <div className="message-in">
                      <ul className="message-in-meta">
                        <li>19:57 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Cupidatat quis ad sint excepteur laborum in esse qui. Et excepteur consectetur ex nisi eu do cillum ad laborum.</p>
                    </div>
                    <div className="message-out">
                      <ul className="message-in-meta">
                        <li>20:07 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Mollit et eu officia dolore sunt Lorem culpa qui commodo velit ex amet id ex. Officia anim incididunt laboris deserunt anim aute dolor incididunt veniam aute dolore do exercitation. Dolor nisi culpa ex ad irure in elit eu dolore. Ad laboris ipsum reprehenderit irure non commodo enim culpa commodo veniam incididunt veniam ad.</p>
                    </div>
                    <div className="message-in">
                      <ul className="message-in-meta">
                        <li>19:57 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Cupidatat quis ad sint excepteur laborum in esse qui. Et excepteur consectetur ex nisi eu do cillum ad laborum.</p>
                    </div>
                    <div className="message-out">
                      <ul className="message-in-meta">
                        <li>20:07 <small>d. 22/10-17</small></li>
                      </ul>
                      <p>Mollit et eu officia dolore sunt Lorem culpa qui commodo velit ex amet id ex. Officia anim incididunt laboris deserunt anim aute dolor incididunt veniam aute dolore do exercitation. Dolor nisi culpa ex ad irure in elit eu dolore. Ad laboris ipsum reprehenderit irure non commodo enim culpa commodo veniam incididunt veniam ad.</p>
                    </div>
                  </div>
                </div>
                <div className="choose-text"><div className="choose-text-inner"><strong>&#8592;</strong> Vælg venligst en samtale</div></div>
              </div>
              <div className="col-sm-4">
                <div className="widget">
                  <h3 className="section-heading">Oplysninger</h3>
                  <form>
                    <div className="form-group">
                      <label htmlFor="name">Alder</label>
                      <input type="email" className="form-control" id="name" placeholder="Alder" value="14" disabled="disabled" />
                    </div>
                    <div className="form-group">
                      <label htmlFor="status">Køn</label>
                      <select className="form-control" id="status" value="male" disabled="disabled">
                        <option value="_none">Vælg køn</option>
                        <option value="male">Dreng</option>
                        <option value="female">Pige</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="status">Tags</label>
                      <Select
                        name="tags"
                        value={[]}
                        options={[]}
                        multi
                        closeOnSelect={false}
                        placeholder="Vælg tags..."
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="exampleFormControlTextarea1">Andre noter</label>
                      <textarea className="form-control" id="exampleFormControlTextarea1" disabled rows={3} value={""} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="list-2" role="tabpanel" aria-labelledby="list-2-list">...</div>
          <div className="tab-pane fade" id="list-3" role="tabpanel" aria-labelledby="list-3-list">...</div>
          <div className="tab-pane fade" id="list-4" role="tabpanel" aria-labelledby="list-4-list">...</div>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Conversation)));



// WEBPACK FOOTER //
// ./src/components/ConversationOverview/components/EmptyConversation/index.js